import {get} from "$lib/api";

export const getEventsByDay = async (day: string) => {
    return await get(`/calendar/${day}`);
}